import { IDepartments } from '../../../../../interface/interfaces';

export const getDepartmentById = (departments: IDepartments[], ids: number[]) => {
    return departments.filter((item: IDepartments) => ids.includes(item.DepartmentId));
};

export const getDepartmentNetwork = (departments: IDepartments[], role: string) => {
    const departmentConnection: IDepartments[] = [];

    const department = departments.find((item: IDepartments) => item.DepartmentName === role);

    if (department) {
        departmentConnection.push(department);
        departmentConnection.push(...getDepartmentById(departments, department.In), ...getDepartmentById(departments, department.Out));
    }

    return departmentConnection;
};
